module.exports = __webpack_public_path__ + "static/media/background_circle_red_modal.822d18dc.svg";